export class CatEmployeeJobModel {
    public employeeJobId?:number;
    public description?:string;
    public displayDescription?:string;

    public activeId?:boolean;
    public createUserId?:number;
    public createDate?:string;
    public modifUserId?:number;
    public modifDate?:string;
}